export enum AutomationStrategyId {
    Dummy
}